import isEmpty from "lodash/fp/isEmpty";
import { SORT_BY_RATE } from "fixtures/constants";

export default (propertyContent) =>
  isEmpty(propertyContent?.customDisplayStep2)
    ? propertyContent?.sortHighToLow
      ? SORT_BY_RATE.HIGH_TO_LOW
      : SORT_BY_RATE.LOW_TO_HIGH
    : SORT_BY_RATE.BY_RATE;
